export const validateField = (field, value, formData = {}) => {
  switch (field) {
    case "firstName":
      return !value?.trim() ? "First name is required." : "";
    case "lastName":
      return !value?.trim() ? "Last name is required." : "";
    case "username":
      return !value?.trim() ? "Username is required." : "";
    case "email":
      if (!value?.trim()) return "Email is required.";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
        return "Please enter a valid email.";
      return "";
    case "password":
      if (!value?.trim()) return "Password is required.";
      if (value.length < 4) return "Password must be at least 4 characters.";
      return "";
    case "confirmPassword":
      if (!value?.trim()) return "Please confirm your password.";
      if (value !== formData.password) return "Passwords do not match.";
      return "";
    default:
      return "";
  }
};

export function validateSignup({
  firstName,
  lastName,
  email,
  username,
  password,
  confirmPassword,
}) {
  const fields = {
    firstName,
    lastName,
    email,
    username,
    password,
    confirmPassword,
  };
  for (const field in fields) {
    const error = validateField(field, fields[field], { password });
    if (error) return error;
  }
  return null;
}
